export default __webpack_public_path__ + "static/media/Yasmine_Williams_Woods_AHV_In_Moms_We_Trust.fd50fbe9.jpg";